import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import { useUIThemeContext } from "@pathwright/ui/src/components/ui/PathwrightUI"
import CompletionFeedbackDetail from "@pathwright/web/src/modules/completion/feedback/CompletionFeedbackDetail"
import pluralize from "pluralize"
import styled from "styled-components"
import NextStep from "./NextStep"
import StepCommentPreview from "./StepCommentPreview"
import StepSkipped from "./StepSkipped"

const FlexAligned = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  > i {
    margin-right: 4px;
  }
`

const StepCompleted = function (props) {
  const {
    step,
    completion,
    nextStep,
    onResetStep,
    canResetStep,
    is_reseting_completion,
    t,
    tc
  } = props
  const pts = t(`step.${pluralize("pt", completion.userpoints_value)}`)
  const theme = useUIThemeContext()

  const pendingReview =
    completion && completion.progress === 1.0 && completion.item_needs_grading

  return (
    <div className="step-completed-container">
      <StepCommentPreview completion={completion} />
      {nextStep ? (
        <div className="up-next-prompt">
          <NextStep {...Object.assign({}, props)} />
        </div>
      ) : (
        <FlexAligned className="StepCompleted__flex-aligned">
          {" "}
          <Pathicon
            icon={pendingReview ? "check-dash" : "check"}
            className="step-completion-icon"
          />
          {t("step.completed")}
        </FlexAligned>
      )}
      <div className="step-complete-stats">
        {completion.is_skipped ? (
          <span>
            <StepSkipped stepId={step.id} />
          </span>
        ) : null}
        {completion.userpoints_value ? (
          <span className="StepCompleted__earned">
            {pendingReview ? (
              <FlexAligned>
                <Pathicon icon="check-dash" />
                {`${completion.userpoints_value}${pts} ${t("step.possible")}`}
              </FlexAligned>
            ) : (
              <FlexAligned>
                <Pathicon icon="check" />
                {t("step.you_earned")}
                {` ${completion.userpoints_earned}/${completion.userpoints_value}${pts}`}
              </FlexAligned>
            )}
          </span>
        ) : undefined}
        <span>
          <CompletionFeedbackDetail stepId={step.id} />
        </span>
        {canResetStep ? (
          <span className="StepCompleted__reset">
            <SubmitButton
              hideSuccess
              submitting={is_reseting_completion}
              onClick={onResetStep}
              styleType="inline"
              className="reset-completion"
              icon="skip-back-2"
              label={t("step.reset")}
            />
            {!is_reseting_completion && (
              <Tooltip
                title={tc(
                  "Your answers will be saved; only your step completion will be reset."
                )}
              >
                <Pathicon
                  icon="info-circle"
                  style={{ marginLeft: "5px", color: theme.primaryBrandColor }}
                />
              </Tooltip>
            )}
          </span>
        ) : completion.overridden_by_api ? (
          <>
            <span className="step-external-api-completion">
              {t("(Completed externally)")}
            </span>
          </>
        ) : null}
      </div>
      {pendingReview ? <span>{t("step.pending_review")}</span> : null}
    </div>
  )
}

StepCompleted.displayName = "StepCompleted"

export default withTranslate(StepCompleted)
